var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciple1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 58H31C29.3431 58 28 56.6568 28 55L28 31C28 29.3431 29.3431 28 31 28H65C66.6569 28 68 29.3431 68 31V55C68 56.6568 66.6569 58 65 58H48ZM48 58V68M48 68H55M48 68H41",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 40.5V53M53.5 53V46M48 53V48M42.5 53V45M37.5 53V50.5M37 44L45 36L50.5 41.5L59 33",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple1);
export default __webpack_public_path__ + "static/media/Principle1.292a8dc3ec949f58af723667c83ded58.svg";
export { ForwardRef as ReactComponent };